module.exports = __webpack_public_path__ + "img/recommend-image.6f039d63.png";